import { __decorate } from "tslib";
import TeethMap from '@/components/Teeth/Map.vue';
import ToothParts from "@/components/Tooth/Parts.vue";
import Vue from "vue";
import { Component, Emit, Prop, Watch } from "vue-property-decorator";
import debounce from "lodash/debounce";
import { mapGetters } from "vuex";
let TeethExamMap = class TeethExamMap extends Vue {
    hoveredTooth = {};
    parts = {};
    states = [];
    toothConditions = [
        {
            label: 'Root',
            value: 'root',
        },
        {
            label: 'Implant',
            value: 'implant',
        },
        {
            label: 'Artificial tooth',
            value: 'artificialtooth',
        },
        {
            label: 'Crown',
            value: 'crown',
        },
        {
            label: 'Depulped',
            value: 'depulped',
        },
        {
            label: 'Plombed',
            value: 'plombed',
        },
        {
            label: 'Missing',
            value: 'missing',
        }
    ];
    findConfsInStore;
    kid;
    value;
    onPartsChange(parts, oldValue) {
        if (JSON.stringify(parts).length === JSON.stringify(oldValue).length)
            return;
        const toothParts = parts[this.hoveredTooth.tooth];
        if (!toothParts)
            return;
        if (toothParts.front) {
            this.setState('periodontitis', toothParts.front.periodontitis);
            this.setState('caries', [
                toothParts.front.first,
                toothParts.front.second,
                toothParts.front.secondLeft,
                toothParts.front.secondRight,
                toothParts.front.third,
                toothParts.front.thirdLeft,
                toothParts.front.thirdRight,
                toothParts.front.fourth,
                toothParts.front.fourthLeft,
                toothParts.front.fourthRight,
                toothParts.front.fifth,
                toothParts.front.six,
                toothParts.front.center
            ].some((part) => part), toothParts);
        }
        if (toothParts.oral) {
            this.setState('pulpitis', toothParts.oral.channel);
            this.setState('caries', [
                toothParts.oral.first,
                toothParts.oral.second,
                toothParts.oral.secondLeft,
                toothParts.oral.secondRight,
                toothParts.oral.third,
                toothParts.oral.thirdLeft,
                toothParts.oral.thirdRight,
                toothParts.oral.fourth,
                toothParts.oral.fourthLeft,
                toothParts.oral.fourthRight,
                toothParts.oral.fifth,
                toothParts.oral.six,
                toothParts.oral.center
            ].some((part) => part), toothParts);
        }
        this.update();
    }
    onValueChanged(value) {
        this.states = value;
    }
    emitValue(newValue) {
        return newValue;
    }
    get teethStates() {
        const result = {};
        const states = this.$deepCopy(this.states);
        states.forEach((state) => {
            result[state.tooth] = result[state.tooth] || { number: state.tooth, state: [] };
            result[state.tooth].state.push(state.diagnosis);
            result[state.tooth].parts = result[state.tooth].parts || state.parts;
        });
        return result;
    }
    get getCoordinatesPopup() {
        if (typeof this.hoveredTooth.coordinates === 'undefined')
            return;
        let coordinates = this.hoveredTooth.coordinates;
        let screenX = window.innerWidth;
        let x = coordinates.x;
        if (coordinates.x < 160)
            x = coordinates.x + (160 - coordinates.x);
        else if (screenX - coordinates.x < 270)
            x = coordinates.x - (270 - (screenX - coordinates.x));
        return {
            top: 0 || (coordinates.y - 200) + 'px',
            left: 0 || (x - 150) + 'px'
        };
    }
    get isLegacyCaries() {
        return this.isDiagnosisOnTooth('caries') && !this.hasCariesPartsByTooth(this.hoveredTooth.tooth);
    }
    mounted() {
        this.states = this.value;
    }
    refreshParts() {
        this.parts = this.extractTeethPartsData();
    }
    get partsClone() {
        return this.$deepCopy(this.parts);
    }
    extractTeethPartsData() {
        const parts = {};
        Object.values(this.teethStates).forEach((tooth) => {
            tooth.state.forEach((state) => {
                const number = tooth.number;
                if (!parts[number])
                    parts[number] = {
                        front: {},
                        oral: {},
                    };
                if (state === 'pulpitis') {
                    parts[number].oral.channel = true;
                }
                else if (state === 'periodontitis') {
                    parts[number].front.periodontitis = true;
                }
                else if (state == 'caries') {
                    parts[number] = tooth.parts;
                }
            });
        });
        return parts;
    }
    hasCariesPartsByTooth(tooth) {
        const toothParts = this.parts[tooth]; // as any is used to fix TS error
        if (!toothParts)
            return false;
        let hasCaries = false;
        const front = toothParts.front;
        const oral = toothParts.oral;
        if (front) {
            hasCaries = [
                front.first,
                front.second,
                front.secondLeft,
                front.secondRight,
                front.third,
                front.thirdLeft,
                front.thirdRight,
                front.fourth,
                front.fourthLeft,
                front.fourthRight,
                front.fifth,
                front.six,
                front.center
            ].some((part) => part);
        }
        if (!hasCaries && oral) {
            hasCaries = [
                oral.first,
                oral.second,
                oral.secondLeft,
                oral.secondRight,
                oral.third,
                oral.thirdLeft,
                oral.thirdRight,
                oral.fourth,
                oral.fourthLeft,
                oral.fourthRight,
                oral.fifth,
                oral.six,
                oral.center
            ].some((part) => part);
        }
        return hasCaries;
    }
    hoverTooth(obj) {
        if (!obj)
            return {};
        if (typeof obj.tooth === 'undefined')
            return;
        if (!this.hoveredTooth) {
            this.hoveredTooth = obj;
        }
        else {
            if (this.hoveredTooth.tooth !== obj.tooth)
                this.hoveredTooth = obj;
        }
    }
    debouncedHoverTooth(obj) {
        debounce(this.hoverTooth, 130)(obj);
    }
    pushState(tooth, diagnosis, optionId, parts = undefined) {
        if (!optionId)
            optionId = (this.findConfsInStore({ query: { condition: diagnosis } }).data[0] || {})._id;
        this.states.push({ tooth, diagnosis, option: optionId, parts });
    }
    update() {
        this.emitValue(this.states);
    }
    isToothMissing() {
        return this.isDiagnosisOnTooth('missing');
    }
    isToothImplant() {
        return this.isDiagnosisOnTooth('implant');
    }
    setState(condition, checked, parts = undefined) {
        if (this.isDisabled(condition))
            return;
        if (checked) {
            this.pushState(this.hoveredTooth.tooth, condition, null, parts);
        }
        else {
            this.states = this.states.filter((state) => state.diagnosis !== condition || state.tooth !== this.hoveredTooth.tooth);
        }
        this.update();
    }
    isDiagnosisOnTooth(diagnosis) {
        if (!this.states)
            return false;
        if (!this.hoveredTooth)
            return false;
        if (!this.hoveredTooth.tooth)
            return false;
        return this.states.some((state) => (state.diagnosis === diagnosis) && (state.tooth === this.hoveredTooth.tooth));
    }
    isDisabled(condition) {
        if (this.isToothMissing() && condition !== 'missing')
            return true;
        if (this.isToothImplant() && condition !== 'implant')
            return true;
        return false;
    }
};
__decorate([
    Prop({ type: Boolean })
], TeethExamMap.prototype, "kid", void 0);
__decorate([
    Prop({ type: Array })
], TeethExamMap.prototype, "value", void 0);
__decorate([
    Watch('partsClone', { deep: true })
], TeethExamMap.prototype, "onPartsChange", null);
__decorate([
    Watch('value', { deep: true })
], TeethExamMap.prototype, "onValueChanged", null);
__decorate([
    Emit('input')
], TeethExamMap.prototype, "emitValue", null);
__decorate([
    Watch('teethStates', { deep: true })
], TeethExamMap.prototype, "refreshParts", null);
TeethExamMap = __decorate([
    Component({
        name: 'TeethExamMap',
        components: { TeethMap, ToothParts },
        computed: {
            ...mapGetters('configurator', { findConfsInStore: 'find' }),
        }
    })
], TeethExamMap);
export default TeethExamMap;
